import { Box, Button, TableCell, TableRow, Typography } from "@mui/material";
import { useState } from "react";
import { useParams } from "react-router-dom";
import Images from "../../../assets";
import { useAppDispatch, useAppSelector } from "../../../assets/hooks";
import ReusableTable from "../../../components/reusableTable";
import { setPopup } from "../../../store/slices/popupSlice";
import { Recommendation } from "../../../types/types";
import { DeleteOutline } from "@mui/icons-material";
import { hiderecommedUniversity } from "../../../services";
import { removeRecommended } from "../../../store/slices/recommendations";
import ConfirmDialog from "../../../components/confirmDialog";

const Recommendations = (props: any) => {
  const { id } = useParams();

  const recommendations = useAppSelector(state => state.recommendations)
  const [activeTab, setActiveTab] = useState<"Safe" | "Ambitious" | "Moderate" | "AdvisorRecommend">(
    "Safe"
  );
  const dispatch = useAppDispatch();
  const columns = [
    {
      name: "University / Course name",
      minWidth: 170
    }, {
      name: "State",
      minWidth: 170
    }, {
      name: "Country",
      minWidth: 170
    }, {
      name: "Course level",
      minWidth: 170
    }, {
      name: "Duration",
      minWidth: 170
    },
    {
      name: "Action",
      minWidth: 100
    },
  ]
  const ambitious: Recommendation[] = recommendations?.data?.filter(
    (item: any) => item?.possibilityOfAdmit === "Ambitious"
  );
  const safe: Recommendation[] = recommendations?.data?.filter(
    (item: any) => item?.possibilityOfAdmit === "Safe"
  );
  const moderate: Recommendation[] = recommendations?.data?.filter(
    (item: any) => item?.possibilityOfAdmit === "Moderate"
  );
  const advisorRecommend: Recommendation[] = recommendations?.data?.filter(
    (item: any) => item?.counsellorRecommended === true
  );

  console.log("Recc Ambi",ambitious);

  const StudentsData = (props: any) => {
    const { data } = props;
    const [open, setOpen] = useState<boolean>(false);
    const [deleteItem, setDeleteItem] = useState()

    const handleDelete = async (i: any) => {
      const response = await hiderecommedUniversity({
        studentId: id,
        recommendId: i._id
      })
      if (response) {
        dispatch(removeRecommended(i._id))
      }
    }

    const handleDeleteOpen = (item: any) => {
      setOpen(true)
      setDeleteItem(item)
    }
    return (
      <>
        {data?.length > 0 ? (
          data?.map((student: any) => (
            <TableRow
              key={student._id}
              sx={{
                "& .MuiTableCell-root": {
                  padding: "8px",
                  borderRightStyle: "solid",
                  borderRightColor: "gray",
                  borderWidth: "1px",
                },
              }}
            // onClick={() =>
            //   window.open(`/student/${student.profile._id}/universities`, "_blank")
            // }
            >
              <TableCell>
                <div
                  style={{
                    color: "#FEB853",
                    fontWeight: 600,
                    display: "flex",
                    justifyContent: "space-between"
                  }}
                >
                  <div style={{
                    display: "flex",
                    gap: "10px",
                  }}>
                    <img
                      src={student?.course?.university.logoSrc}
                      alt="logo"
                      style={{ width: "1.5rem",height: "1.5rem", borderRadius: "5px" }}
                    />
                    {student.course?.university.name}
                  </div>

                  {student?.counsellorRecommended === true ?
                    <img src={Images.recommended} alt="logo" /> : ""}
                </div>
                <div style={{ fontWeight: 500 }}>{student.course.name}</div>
              </TableCell>
              <TableCell>
                <div style={{ fontWeight: 500 }}>
                  {student.course?.university.location.state}
                </div>
              </TableCell>
              <TableCell>
                <div style={{ fontWeight: 500 }}>
                  {student.course?.university.location.country}
                </div>
              </TableCell>
              <TableCell>
                <div style={{ fontWeight: 500 }}>
                  {student.course.studyLevel}
                </div>
              </TableCell>
              <TableCell>
                <div style={{ fontWeight: 500 }}>
                {
                  student.course?.duration?.reduce((acc:string,curr:any,i:number)=>(acc+(`${curr?.durationType}:${curr?.duration}`)+(i<student?.course?.duration?.length-1?",":"")),"")
                }
                </div>
              </TableCell>
              <TableCell>
                <div style={{ fontWeight: 500 }}>
                  <DeleteOutline sx={{ fontSize: "1.25rem",cursor:"pointer" }} onClick={() => handleDeleteOpen(student)} />
                </div>
              </TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
            <TableCell colSpan={6}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography align="center">No data available</Typography>
              </div>
            </TableCell>
          </TableRow>
        )}
        <ConfirmDialog
          open={open}
          handleClose={() => setOpen(false)}
          additionalData={{
            onSubmit: () => handleDelete(deleteItem),
            title: "Are you sure you want to delete package?",
            content: "",
          }}
        />
      </>
    );
  };

  return (
    <div>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Box sx={{ display: "flex", gap: "10px" }}>
          <Button
            onClick={() => setActiveTab("Safe")}
            sx={{
              color: activeTab === "Safe" ? "#000" : "#7C7A7A",
              background: activeTab === "Safe" ? "#FEB853" : "",
              borderRadius: "10px",
              textTransform: "none",
              fontSize: "1rem",
              "&:hover": {
                background: "#FEB853",
                color: "#000"
              },
              height: "40px"
            }}
          >
            Safe ({safe && (safe)?.length})
          </Button>
          <Button
            sx={{
              color: activeTab === "Moderate" ? "#000" : "#7C7A7A",
              background: activeTab === "Moderate" ? "#FEB853" : "",
              borderRadius: "10px",
              textTransform: "none",
              fontSize: "1rem",
              "&:hover": {
                background: "#FEB853",
                color: "#000"
              },
              height: "40px"
            }}
            onClick={() => setActiveTab("Moderate")}
          >
            Moderate ({moderate && (moderate)?.length})
          </Button>
          <Button
            sx={{
              color: activeTab === "Ambitious" ? "#000" : "#7C7A7A",
              background: activeTab === "Ambitious" ? "#FEB853" : "",
              borderRadius: "10px",
              textTransform: "none",
              fontSize: "1rem",
              "&:hover": {
                background: "#FEB853",
                color: "#000"
              },
              height: "40px"

            }}
            onClick={() => setActiveTab("Ambitious")}
          >
            Ambitious ({ambitious && (ambitious)?.length})
          </Button>
          <Button
            sx={{
              color: activeTab === "AdvisorRecommend" ? "#000" : "#7C7A7A",
              background: activeTab === "AdvisorRecommend" ? "#FEB853" : "",
              borderRadius: "10px",
              textTransform: "none",
              fontSize: "1rem",
              "&:hover": {
                background: "#FEB853",
                color: "#000"
              },
              height: "40px"
            }}
            onClick={() => setActiveTab("AdvisorRecommend")}
          >
            Advisor Recommend ({advisorRecommend?.length})
          </Button>
        </Box>
        <Box sx={{
          display: "flex", justifyContent: "center", mt: 2
        }}>
          <Button
            sx={{
              color: "#fff",
              background: "#3B3F76",
              borderRadius: "5px",
              textTransform: "none",
              fontSize: "0.8rem",
              "&:hover": {
                background: "#3B3F76",
              },
            }}
            onClick={() =>
              dispatch(
                setPopup({
                  show: true,
                  data: {
                    container: {
                      name: "addRecommendation",
                      data: id,
                      dimensions: {
                        width: "500px",
                      },
                    },
                    type: "custom",
                  },
                })
              )}>Recommend course</Button>
        </Box>
      </Box>


      {activeTab === "Safe" ? (
        <ReusableTable
          columns={columns}
          data={<StudentsData data={safe} />}
          rowOnClick={undefined}
        />
      ) : activeTab === "Ambitious" ? (
        <ReusableTable
          columns={columns}
          data={<StudentsData data={ambitious} />}
          rowOnClick={undefined}
        />
      ) : activeTab === "Moderate" ? (
        <ReusableTable
          columns={columns}
          data={<StudentsData data={moderate} />}
          rowOnClick={undefined}
        />
      ) : (
        <ReusableTable
          columns={columns}
          data={<StudentsData data={advisorRecommend} />}
          rowOnClick={undefined}
        />
      )}

    </div>
  );
};

export default Recommendations;
